module.exports = __webpack_public_path__ + "static/media/CarryOn_LargeLaggage_Arrows.170cf4fb.glb";